// src/apiConfig.js
export const API_BASE = "https://0855mq40p3.execute-api.us-east-1.amazonaws.com/dev";
